import {
    apiRequest,
    refBknJabatanStrukturalList,
    syncDataBknJabatanStruktural
} from "../../../../../../services/adapters/master/refBknJabatanStrukturalService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", refBknJabatanStrukturalList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchSyncData = async (query, cancelToken) => {
        return await apiRequest("get", syncDataBknJabatanStruktural, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository